import Cookies from "js-cookie";

export function setCookieWithLifetime(cookieName, value, hoursToLive) {
  var cookieDate = new Date();
  cookieDate.setTime(cookieDate.getTime() + hoursToLive * 60 * 60 * 1000);

  Cookies.set(cookieName, value, {
    expires: cookieDate,
    path: "/",
    secure: true,
  });
}

export function setAbholfilialeCookies(filialId) {
  setCookieWithLifetime("temp_abholfiliale", filialId, 4);
  setCookieWithLifetime("such_abholfiliale", filialId, 4);
}

export function getAbholfilialeCookie() {
  return Cookies.get("abholfiliale");
}

export function getTempAbholfilialeCookie () {
  return Cookies.get("temp_abholfiliale");
}

export function getSuchAbholfilialeCookie() {
  return Cookies.get("such_abholfiliale");
}

export function getCSRFGlobalCookie() {
  return Cookies.get("csrf_global");
}